export const LEAD_STATUS_OPTIONS = [
  { value: 'new', label: 'New' },
  { value: 'contacted', label: 'Contacted' },
  { value: 'qualified', label: 'Qualified' },
  { value: 'quoted', label: 'Quoted' },
  { value: 'won', label: 'Won' },
  { value: 'lost', label: 'Lost' },
];

const LABEL_MAP = Object.fromEntries(LEAD_STATUS_OPTIONS.map((o) => [o.value, o.label]));

export function labelForLeadStatus(value) {
  if (value == null || value === '') return '';
  return LABEL_MAP[value] || value;
}
